// extracted by mini-css-extract-plugin
export default {"mobileTitle":"oHtWgR57gA8aDZVkEHOz"};